import { Username } from '#app/lib/regex'
import { treq } from '#app/lib/treq'
import { pass } from '#general/lib/forms'

async function verifyUsernameAvailability (username: string) {
  await treq('auth', 'get', 'username-availability', { username })
}

export function passUsernameTests (username: string) {
  return pass({
    value: username,
    tests: usernameTests,
  })
}

export async function verifyUsername (username: string) {
  passUsernameTests(username)
  await verifyUsernameAvailability(username)
}

const usernameTests = {
  'username should be 2 characters minimum' (username: string) { return username.length < 2 },
  'username should be 20 characters maximum' (username: string) { return username.length > 20 },
  "username can't contain space" (username: string) { return /\s/.test(username) },
  'username can only contain letters, figures or _' (username: string) { return !Username.test(username) },
}
